module.exports = __webpack_public_path__ + "img/bcebe8b9862141ff03901efddb8ad1a0.jpg";